module.exports = __webpack_public_path__ + "img/silencer.a75c78bb.png";